import { createContext, useContext, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/contexts/RegionScopeContext.tsx
var RegionScopeContext = createContext(void 0);
/**
* Provides an ambient region scope (array of region ids) to a subtree.
* Region-scoped pickers read this via useRegionScope() and use it as their
* default region filter, so a picker rendered inside (e.g.) a Location is
* automatically scoped to that Location's region with no call-site code.
*/
function RegionScopeProvider({ children, regionIds }) {
	const value = useMemo(() => regionIds, [regionIds ? regionIds.join(",") : ""]);
	return /* @__PURE__ */ jsx(RegionScopeContext.Provider, {
		value,
		children
	});
}
/**
* Returns the ambient region scope for the current subtree, or `undefined`
* when no RegionScopeProvider is mounted. When undefined, callers should omit
* the region argument entirely (preserving transport-metadata-based scoping).
*/
function useRegionScope() {
	return useContext(RegionScopeContext);
}
//#endregion
export { RegionScopeProvider, useRegionScope };

//# sourceMappingURL=RegionScopeContext.js.map